module.exports = __webpack_public_path__ + "static/img/vendor.da37e2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vendor.png
// module id = iUZN
// module chunks = 1